import { ReactComponent as IconHTML } from "../imgs/mini-icon-set-CC3/html5-flat.svg";
import { ReactComponent as IconCSS } from "../imgs/mini-icon-set-CC3/css-flat.svg";
import { ReactComponent as IconJavaScript } from "../imgs/mini-icon-set-CC3/javascript.svg";
import { ReactComponent as IconTypeScript } from "../imgs/mini-icon-set-CC3/typescript.svg";
import { ReactComponent as IconPython } from "../imgs/mini-icon-set-CC3/python.svg";
import { ReactComponent as IconReact } from "../imgs/mini-icon-set-CC3/react.svg";
import { ReactComponent as IconGit } from "../imgs/mini-icon-set-CC3/git.svg";
import { ReactComponent as IconGitHub } from "../imgs/mini-icon-set-CC3/github.svg";
import { ReactComponent as IconNPM } from "../imgs/mini-icon-set-CC3/npm.svg";
import { ReactComponent as IconLinux } from "../imgs/mini-icon-set-CC3/linux.svg";
import { ReactComponent as IconWindows } from "../imgs/mini-icon-set-CC3/microsoft.svg";
import { ReactComponent as IconTailwind } from "../imgs/mini-icon-set-CC3/tailwind.svg";

import { ReactComponent as IconNodeJs } from "../imgs/svg-logos-CC3/nodejs.svg";
import { ReactComponent as IconNodeJs2 } from "../imgs/svg-logos-CC3/nodejs-2.svg";
import { ReactComponent as IconElectron } from "../imgs/mini-icon-set-CC3/electron.svg";

import { ReactComponent as IconWord } from "../imgs/logos/037-word.svg";
import { ReactComponent as IconExcel } from "../imgs/logos/043-excel.svg";
import { ReactComponent as IconPowerPoint } from "../imgs/logos/039-powerpoint.svg";
import { ReactComponent as IconOutlook } from "../imgs/logos/040-outlook.svg";
import { ReactComponent as IconFigma } from "../imgs/mini-icon-set-CC3/figma.svg";
import { ReactComponent as IconAdobeXd } from "../imgs/mini-icon-set-CC3/adobexd.svg";

const icons = {
  IconHTML,
  IconCSS,
  IconJavaScript,
  IconTypeScript,
  IconPython,
  IconReact,
  IconGit,
  IconGitHub,
  IconLinux,
  IconWindows,
  IconNPM,
  IconNodeJs,
  IconNodeJs2,
  IconElectron,
  IconWord,
  IconExcel,
  IconPowerPoint,
  IconOutlook,
  IconFigma,
  IconAdobeXd,
  IconTailwind,
};

export default icons;
